import type { SoundClipsLocale } from './en'

export const soundClipsEs = {
  list: {
    title: 'Clips de Sonido',
    loading: 'Cargando clips de sonido...',
    error: 'Error',
    empty: 'No se encontraron clips de sonido',
    emptyDescription:
      'Actualmente no hay clips de sonido configurados para este PBX.',
    noResults: 'Sin resultados',
    noResultsDescription: 'Ningún clip de sonido coincide con tu búsqueda.',
    columnName: 'Nombre',
    columnFeatureCode: 'Código de Función',
    columnUpdated: 'Actualizado',
    columnActions: 'Acciones',
    featureCodeNone: 'N/A',
    createButton: '+ Nuevo Clip de Sonido',
    deleteConfirmTitle: 'Eliminar Clip de Sonido',
    deleteConfirmMessage:
      '¿Estás seguro de que deseas eliminar "{{name}}"? Esta acción no se puede deshacer.',
    deleteConfirmButton: 'Eliminar',
    deleteSuccess: 'Clip de sonido eliminado.',
    deleteError: 'Error al eliminar el clip de sonido.',
    searchPlaceholder: 'Buscar clips de sonido...',
    recordingInfo:
      'Marca *99 desde tu teléfono para grabar un nuevo clip de sonido. Marca *100–*109 para regrabar un clip existente.',
    audioLoadError:
      'No se pudo cargar el audio — es posible que deba regrabarse.',
  },
  create: {
    title: 'Nuevo Clip de Sonido',
    nameLabel: 'Nombre',
    namePlaceholder: 'Ingresa el nombre del clip de sonido',
    featureCodeLabel: 'Código de Función',
    featureCodeNone: 'Ninguno',
    audioFileLabel: 'Archivo de Audio',
    audioFilePlaceholder:
      'Arrastra y suelta un archivo WAV o MP3 aquí, o haz clic para explorar',
    audioFileAccepted: 'WAV, MP3 (máx. 25 MB)',
    cancel: 'Cancelar',
    submit: 'Subir Clip de Sonido',
    creating: 'Subiendo...',
    success: 'Clip de sonido creado exitosamente.',
    error: 'Error al crear el clip de sonido.',
    nameRequired: 'El nombre es obligatorio.',
    audioFileRequired: 'Se requiere un archivo de audio.',
  },
  edit: {
    title: 'Editar Clip de Sonido',
    loading: 'Cargando clip de sonido...',
    notFound: 'Clip de sonido no encontrado.',
    backToList: '← Volver a la lista',
    nameLabel: 'Nombre',
    namePlaceholder: 'Ingresa el nombre del clip de sonido',
    featureCodeLabel: 'Código de Función',
    featureCodeNone: 'Ninguno',
    audioFileLabel: 'Reemplazar Archivo de Audio',
    audioFilePlaceholder:
      'Arrastra y suelta un nuevo archivo para reemplazar, o haz clic para explorar',
    audioFileAccepted: 'WAV, MP3 (máx. 25 MB)',
    currentAudio: 'Audio Actual',
    playCurrentAudio: 'Reproducir Audio Actual',
    stopAudio: 'Detener',
    audioLoadError:
      'No se pudo cargar el audio de este clip — es posible que deba regrabarse.',
    createdLabel: 'Creado',
    updatedLabel: 'Última Actualización',
    cancel: 'Cancelar',
    submit: 'Guardar Cambios',
    saving: 'Guardando...',
    success: 'Clip de sonido actualizado exitosamente.',
    error: 'Error al actualizar el clip de sonido.',
    deleteButton: 'Eliminar Clip de Sonido',
  },
  upload: {
    invalidType: 'Tipo de archivo no admitido. Sube un archivo WAV o MP3.',
    tooLarge: 'El archivo es demasiado grande. El tamaño máximo es 25 MB.',
  },
} satisfies SoundClipsLocale
